<template>
  <Toast />
  <Card class="text-center">
    <template #title>
      <h3>Registrar Solicitação</h3>
    </template>
    <template #subtitle>
      <h5>Registre uma solicitação para atendimento técnico.</h5>
    </template>
    <template #content>
      <div class="md:col-8 md:col-offset-2">
        <div class="p-fluid text-left">
          <div class="field">
            <label for="name">Nome</label>
            <InputText type="text" v-model="selectRequester.nome" disabled>
            </InputText>
          </div>
          <div class="field">
            <label for="local">Local</label>
            <Dropdown
              id="local"
              :options="locals"
              optionLabel="name"
              placeholder="Selecione o local"
              :filter="true"
              v-model="solicitation.sector.local"
              @change="findSectors"
            >
            </Dropdown>
          </div>
          <div class="field">
            <label for="sector">Setores</label>
            <Dropdown
              id="sector"
              :options="sectors"
              :optionLabel="label"
              placeholder="Selecione o setor"
              :filter="true"
              v-model="solicitation.sector"
              @filter="onFilter($event)"
            >
            </Dropdown>
          </div>
          <div class="field">
            <label for="solicitation">Solicitação</label>
            <Textarea
              id="solicitation"
              placeholder="Digite sua solicitação"
              v-model="solicitation.description"
              rows="5"
              cols="30"
              :autoResize="true"
              required
            />
          </div>
          <div class="field-checkbox">
            <Checkbox
              inputId="binary"
              v-model="solicitation.priority"
              :binary="true"
            />
            <label for="binary">Prioridade</label>
          </div>
          <div class="field">
            <Button
              icon="pi pi-check"
              label="Salvar"
              class=""
              :disabled="!solicitation.sector.id"
              @click="registrarSolicitacao"
            />
          </div>
        </div>
      </div>
    </template>
  </Card>
</template>

<script>
// Services
import SectorService from "../../service/sector/sector_service";
import SolicitationService from "../../service/solicitation/solicitation_service";
import LocalService from "../../service/local/local_service";

// Models
import Solicitation from "../../models/internal/solicitation";
import SolicitationDTO from "../../models/dto/solicitation_dto";
export default {
  data() {
    return {
      solicitation: new Solicitation(),
      localService: new LocalService(),
      sectorService: new SectorService(),
      solicitationService: new SolicitationService(),
      sectors: [],
      locals: [],
      setoresFiltrados: [],
      selectRequester: this.$store.state.userLogged,
    };
  },
  computed: {
    label() {
      return this.setoresFiltrados.length > 0 ? "acronym" : "name";
    },
  },
  created() {},
  mounted() {
    this.findLocais();
  },
  methods: {
    findLocais() {
      this.localService
        .findAll()
        .then((res) => {
          this.locals = res;
        })
        .catch(() => {
          this.$toast.add({
            severity: "error",
            detail: `Desculpe. Não foi possível carregar os dados.`,
          });
        });
    },
    findSectors() {
      if (this.solicitation.sector.local != null) {
        this.sectorService
          .findByLocal(this.solicitation.sector.local.id)
          .then((data) => {
            this.sectors = data;
          })
          .catch(() => {
            this.$toast.add({
              severity: "error",
              detail: `Desculpe. Não foi possível carregar os dados.`,
            });
            this.sectors = [];
          });
      } else {
        this.sectors = [];
      }
    },
    registrarSolicitacao() {
      this.solicitation.status = "EM_ABERTO";
      this.solicitation.requester = this.selectRequester.personId;
      let dto = new SolicitationDTO(this.solicitation);
      dto.operator = null;
      this.solicitationService
        .registerSolicitation(dto)
        .then((res) => {
          if (res.status === 201) {
            this.$toast.add({
              severity: "success",
              summary: "Nº PROTOCOLO: 0000" + res.data.id + ".",
              detail: `Obrigado! Sua solicitação foi registrada com sucesso. Para acompanhar seu atendimento, selecione 'Acompanhar e Avaliar Atendimento' informando o número do protocolo.`,
            });
            this.solicitation = new Solicitation();
          }
        })
        .catch((error) => this.$msgErro(error));
    },
    onFilter(event) {
      if (!event.value) {
        this.setoresFiltrados = [];
      } else {
        this.setoresFiltrados = this.sectors.filter(
          (item) =>
            item.acronym.includes(event.value) ||
            item.name.includes(event.value)
        );
      }
    },
  },
};
</script>

<style></style>
